import React, { Fragment } from 'react'
import { Intro, MultipleChoice } from 'cvs-core'
import image from '../../assets/images/U1-T1-6c.svg'

const data = {
  question: (
    <Fragment>
      Joey saw his best friend vaping after football practice, and now he keeps
      asking Joey to try it. Joey knows the dangers of using e-cigarettes and
      doesn’t want to risk his spot on the team. He knows most of his friends
      aren’t vaping. One way to get out of the situation without caving into
      peer pressure is to remind his friend about the possible social
      consequences of vaping. Which is NOT an example of a{' '}
      <em className="underline">social consequence</em> of vaping?
    </Fragment>
  ),
  inputType: 'radio',
  options: [
    {
      label: 'They could damage their lungs, mouth, and throat from vaping.',
    },
    {
      label:
        'It’s illegal for minors to be vaping and they could get into trouble.',
    },
    {
      label:
        'They could get kicked off the football team if their coach found out.',
    },
    {
      label:
        'If their parents found out they might not want them to hang out together.',
    },
  ],
}

const correctInput = {
  [data.question]: data.options[0].label,
}

const feedback = {
  success: {
    title: 'That’s right!',
    body:
      'Not only are there health risks associated with vaping or using e-cigarettes, but there are social consequences that can affect your relationships with friends and family.',
  },
  error: {
    title: 'Not quite.',
    body:
      'You selected an example of a social consequence. While there are several social consequences of vaping there are health consequences as well - like damage to your lungs, mouth and throat. You will learn more about this in the module.',
  },
}

export default {
  title: 'Question 3',
  path: '/prepare/question-3',
  content: (
    <Fragment>
      <Intro title="Question 3" img={image} />
      <MultipleChoice
        data={data}
        correctInput={correctInput}
        feedback={feedback}
      />
    </Fragment>
  ),
}



// WEBPACK FOOTER //
// ./src/data/Prepare/Question3.js